import React, { Component } from 'react';
import PropTypes from 'prop-types';
import FormattedTime from '../FormattedTime';
import CroppedImage from '../CroppedImage';

export default class ReceivedCouponListItem extends Component {

  constructor() {
    super();

    this.replaceToCustomScheme = this.replaceToCustomScheme.bind(this);
    this.getDDay = this.getDDay.bind(this);
    this.getDimmedType = this.getDimmedType.bind(this);
  }

  replaceToCustomScheme(permalink) {
    const { couponInfo } = this.props;

    // FROM - permalink : http://sandbox-pf.kakao.com/_jlM/coupons/_VZo51n
    // TO - customScheme : alphaplus://plusfriend/coupon/_vdV/_Kgo51n
    let temp = "";
    if (permalink.match('sandbox-')) {
      temp += "alphaplus://plusfriend/coupon/"
    } else {
      temp += "kakaoplus://plusfriend/coupon/"
    }

    return temp + couponInfo.coupon.profileId + "/" + couponInfo.coupon.id;
  }

  getDDay(entryEndAt) {
    const result = entryEndAt - (new Date());
    return Math.floor(result / (86400 * 1000))
  }

  getDimmedType() {
    const { showUsed, showOutdated } = this.props;

    if (showUsed) {
      return "used";
    } else if (showOutdated) {
      return "outDated";
    }
    return "";
  }

  render() {
    const { type, couponInfo, showDDay, showUsed, showOutdated } = this.props;

    return (
      <li>
        <a href={this.replaceToCustomScheme(couponInfo.coupon.permalink)}
          className={`link_coupon ${(showUsed|| showOutdated) && 'on'}`}
        >
          <div className="item_coupon">
            <CroppedImage src={couponInfo.coupon.entryImage.mediumUrl} className="thumb_coupon"
              alt={couponInfo.coupon.title} dimmed={this.getDimmedType()} />
            <div className="info_coupon">
              <strong className="tit_coupon"> {couponInfo.coupon.author.nickname} </strong>
              <span className="txt_coupon"> {couponInfo.coupon.title} </span>
            </div>
          </div>
          <div className="date_coupon">
            {showUsed ? (<span>
                사용완료일 : <FormattedTime value={couponInfo.couponLog.usedAt}/>
                </span>) :
              (<span className="txt_date">
                {type === 'recommendeds' ? (
                  <span>응모기간 : <FormattedTime value={couponInfo.coupon.entryStartAt} />
                    &nbsp;~ <FormattedTime value={couponInfo.coupon.entryEndAt} /> 까지
                  </span>
                  ) :
                  (showOutdated ? (<span>기간만료일 : <FormattedTime value={couponInfo.coupon.usedEndAt} /> 까지
                  </span>)
                    : (<span>유효기간 : <FormattedTime value={couponInfo.coupon.usedEndAt} /> 까지
                  </span>))}
                </span>)
            }
            {showDDay && showUsed &&
              (<span className="txt_day txt_before">{this.getDDay(couponInfo.coupon.entryEndAt) === 0 ? '오늘' : `D-${this.getDDay(couponInfo.coupon.entryEndAt)}`}</span>)}
            {showDDay && !showUsed &&
              (<span className="txt_day txt_before">{this.getDDay(couponInfo.coupon.usedEndAt) === 0 ? '오늘' : `D-${this.getDDay(couponInfo.coupon.usedEndAt)}`}</span>)}
            {showUsed && (<span className="txt_day">사용완료</span>)}
            {showOutdated && (<span className="txt_day">기간만료</span>)}
          </div>
          {!(showUsed || showOutdated) && (
            <span className="txt_store">
              <em className="screen_out">쿠폰 사용처</em>
                {couponInfo.coupon.onlineFlag ? '온라인' : '매장'}
            </span>
          )}
        </a>
      </li>
    );
  }
}

ReceivedCouponListItem.propTypes = {
  showDDay: PropTypes.bool.isRequired,
  showUsed: PropTypes.bool.isRequired,
  showOutdated: PropTypes.bool.isRequired
};

ReceivedCouponListItem.defaultProps = {
  showDDay: false,
  showUsed: false,
  showOutdated: false
};



// WEBPACK FOOTER //
// ./src/components/ReceivedCouponList/ReceivedCouponListItem.js